import { useMemo } from 'react';

export function useBadgeColor(name?: string | null) {
  return useMemo(() => {
    // Fallback for null / undefined
    if (!name) {
      return 'bg-gray-100 text-gray-500';
    }

    // --- Hash function ---
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.toLowerCase().charCodeAt(i) + ((hash << 5) - hash);
    }
    hash = Math.abs(hash)*6;

    // --- Tailwind-safe color palette ---
    const COLORS = [
      'bg-blue-100 text-blue-800',
      'bg-green-100 text-green-800',
      'bg-purple-100 text-purple-800',
      'bg-pink-100 text-pink-800',
      'bg-yellow-100 text-yellow-800',
      'bg-indigo-100 text-indigo-800',
      'bg-red-100 text-red-800',
      'bg-teal-100 text-teal-800',
      'bg-orange-100 text-orange-800',
      'bg-cyan-100 text-cyan-800',
    ];

    const index = hash % COLORS.length;
    return COLORS[index];
  }, [name]);
}
